module.exports = __webpack_public_path__ + "css/OceanVolt.6db653e0.css";